import { render, staticRenderFns } from "./device.vue?vue&type=template&id=5d23672d&scoped=true"
import script from "./device.vue?vue&type=script&lang=js"
export * from "./device.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/public-style.css?vue&type=style&index=0&id=5d23672d&prod&scoped=true&lang=css&external"
import style1 from "./device.vue?vue&type=style&index=1&id=5d23672d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d23672d",
  null
  
)

export default component.exports